export const textAndIconCard2023Gql = /* GraphQL */ `
... on landingPageContent2023_textIconCardsV2_BlockType {
  id
  typeHandle
  componentTheme:textIconCardLP2ComponentTheme
  cardStyle:textIconCardLP2CardStyle
  alignCenter
  cards:textIconCardLP2 {
    ... on textIconCardLP2_BlockType {
      cardDescription
      cardSubtitle
      cardTitle
      icon {
        ... on svgIcons_Asset {
          url
          title
        }
      }
      cardTheme:textIconCardLP2CardTheme
      cardLink {
        ariaLabel
        customText
        url
        target
        text
      }
    }
  }
}`;
